import { createFileRoute } from '@tanstack/react-router'
import { SecurityTab } from '@/pages/Settings'

export const Route = createFileRoute('/_authenticated/settings/security')({
  component: SecurityTab,
})
